
import { GET_ORGANIZATIONS } from '../types';
import createAsyncActions from '../utilities/createAsyncActions';

export const {
  getOrganizations,
  getOrganizationsPending,
  getOrganizationsFulfilled,
  getOrganizationsRejected,
} = createAsyncActions(GET_ORGANIZATIONS, 'getOrganizations');


// WEBPACK FOOTER //
// ./src/actions/getOrganizationsActions.js